// extracted by mini-css-extract-plugin
module.exports = {"logo":"footer-module--logo--S7vUW","social":"footer-module--social--1wDJr"};